/**
 * Main entry point for only Floodgate with UI support
 * By using makeFloodgate, it will return the Floodgate object.
 */
///<reference path="./typings/OfficeBrowserFeedback.d.ts"/>
import * as Window from "./scripts/app/Window/Window";
import "./scripts/app/App_Floodgate";
export function makeFloodgate() {
  return Window.get().OfficeBrowserFeedback;
}